import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const PostTrackAccess = (moduleId, moduleName, userId) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Analytics/TrackAccess`,
		data: { moduleId, moduleName, userId }
	});

export const GetDashboardData = (days = 21, topN = 10) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Analytics/GetDashboardData`,
		params: { days, topN }
	});

export const GetFilteredData = (days = 21, topN = 10, moduleId = null, userId = null, roleId = null) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Analytics/GetDashboardData`,
		params: {
			days, topN,
			...(moduleId && { moduleId }),
			...(userId   && { userId }),
			...(roleId   && { roleId }),
		}
	});

// Returns hourly breakdown + recent log for a specific date
export const GetHourlyByDate = (date, moduleId = null, userId = null, roleId = null) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Analytics/GetHourlyByDate`,
		params: {
			date,
			...(moduleId && { moduleId }),
			...(userId   && { userId }),
			...(roleId   && { roleId }),
		}
	});

// Returns all available roles
export const GetRoles = () =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Analytics/GetRoles`,
	});